import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { firstValueFrom, forkJoin } from 'rxjs';
import { LoadingPanelService,SvgLoaderComponent } from 'lib-base';
import { FirmaElectronicaTokenService } from '../../../../services/firmaElectronicaToken.service';
import { ProcesarTramiteComponent } from '../procesar-tramite.component';

@Component({
  selector: 'app-enviar-token-firma-electronica',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule,SvgLoaderComponent],
  template: `
    <section>
      <p-dialog [(visible)]="displayDialog" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="false"
                [maximizable]="false" [closable]="false"  [breakpoints]="{'2000px': '686px', '1900px': '686px', '1700px': '686px',
               '1400px': '686px', '960px': '70vw', '640px': '90vw', '490px':'94vw'}">
        <ng-template pTemplate="content">
          <div class="flex flex-column gap-2 align-content-center align-items-center">
            <div>
              <svg-loader name="ico-token-sign"/>
            </div>
            <h1 class="font-bold color-blue-2 font-23 my-0 font-principal ">
              {{ translations.header }}
            </h1>
            <span class="app-text-gray font-13 mb-3">
                {{ translations.subHeader }}
            </span>
            <p class="font-bold font-18 my-0 pb-2">
              {{ translations.bodyHeader }}
            </p>
            <div class="mb-1">
              <button pButton class="p-button-outlined h-3rem w-24rem"
                      [rounded]="true" (click)="porCorreo()">
                <i class="pi pi-envelope font-18 mr-2"></i>
                <span class="font-16">{{ translations.option1 }}</span>
              </button>
            </div>
            <div class="pb-2">
              <button pButton class="p-button-outlined h-3rem w-24rem p-button-rounded"
                      (click)="porMensajeTexto()">
                <i class="pi pi-comment font-18 mr-2"></i>
                <span class="font-16">{{ translations.option2 }}</span>
              </button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="footer">
        </ng-template>
      </p-dialog>
    </section>
  `,
  styleUrl: './enviar-token-firma-electronica.component.scss'
})
export class EnviarTokenFirmaElectronicaComponent implements OnInit {

  @Output() onOptionSelected = new EventEmitter<'correo'|'sms'>();

  displayDialog = false;
  translations: any = {};

  constructor(private _t: TranslateService) { }

  ngOnInit() {
    this.translate();
  }

  private async translate(): Promise<void>{
    this.translations = await firstValueFrom(forkJoin({
      header: this._t.get('components.app-enviar-token-firma-electronica.header'),
      subHeader: this._t.get('components.app-enviar-token-firma-electronica.sub-header'),
      bodyHeader: this._t.get('components.app-enviar-token-firma-electronica.body-header'),
      option1: this._t.get('components.app-enviar-token-firma-electronica.option1'),
      option2: this._t.get('components.app-enviar-token-firma-electronica.option2')
    }));
  }

  showDialog() {
    this.displayDialog = true;
  }

  hideDialog() {
    this.displayDialog = false;
  }

  porMensajeTexto() {
    this.onOptionSelected.emit('sms');
  }

  porCorreo() {
    this.onOptionSelected.emit('correo');
  }
}
